import React, { HTMLAttributes, Suspense } from 'react';

import {
  DesignSystemIconName,
  getDesignSystemIconComponent,
} from './designSystemIconMap';
import styles from './Icon.module.scss';
import {
  DesignSystemIconSize,
  DesignSystemIconTone,
  getIconClasses,
  getIconSizeValue,
} from './utils';

type Props = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  name: DesignSystemIconName;
  size?: DesignSystemIconSize;
  tone?: DesignSystemIconTone;
  label?: string;
};

export const Icon = ({
  name,
  size = DesignSystemIconSize.MEDIUM,
  tone = DesignSystemIconTone.PRIMARY,
  label,
  className,
  ...props
}: Props): JSX.Element => {
  const pixelSize = getIconSizeValue(size);
  const SvgIcon = getDesignSystemIconComponent(name);

  return (
    <span
      className={getIconClasses({ size, tone, className })}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      {...props}
    >
      <Suspense
        fallback={
          <span
            aria-hidden={true}
            className={styles.skeleton}
            style={{ height: pixelSize, width: pixelSize }}
          />
        }
      >
        <SvgIcon
          width={pixelSize}
          height={pixelSize}
          focusable="false"
          aria-hidden="true"
        />
      </Suspense>
    </span>
  );
};

export type { Props as IconProps };
